import { styled } from 'styled-components';

import { Container, Flex, Text, theme } from '@foradevelopment/fora-ui';
import { trimLeadingZeros } from '@fora-monorepo/string-utils';

import { useTypedTranslation } from '../../i18n/i18n';

type Details = { organizationNumber: string; partnerNumber: string; agreementNumber?: string | null };

type EmployerDetailsProps = Details & { layout: 'row' | 'column' };

export const EmployerDetails = ({
  agreementNumber,
  organizationNumber,
  partnerNumber,
  layout,
}: EmployerDetailsProps) => {
  const { t } = useTypedTranslation();

  return layout === 'row' ? (
    <Flex columnGap={20}>
      <Text color="black20">{t('header.customerNumber', { partnerNumber: trimLeadingZeros(partnerNumber) })}</Text>
      <Text color="black20">
        {t('header.agreementNumber', { agreementNumber: trimLeadingZeros(agreementNumber ?? '') })}
      </Text>
      <Text color="black20">{t('common.organizationNumberWithVariable', { orgNumber: organizationNumber })}</Text>
    </Flex>
  ) : (
    <CompanyDetailsWithDots
      partnerNumber={partnerNumber}
      agreementNumber={agreementNumber}
      organizationNumber={organizationNumber}
    />
  );
};

const CompanyDetailsWithDots = ({ organizationNumber, partnerNumber, agreementNumber }: Details) => {
  const { t } = useTypedTranslation();

  return (
    <Container width="100%">
      <DottedContainer marginBottom={10}>
        <TextLeft>{t('common.organizationNumber')}</TextLeft>
        <TextRight>{organizationNumber}</TextRight>
      </DottedContainer>
      <DottedContainer marginBottom={10}>
        <TextLeft>{t('common.customerNumber')}</TextLeft>
        <TextRight>{trimLeadingZeros(partnerNumber)}</TextRight>
      </DottedContainer>
      <DottedContainer>
        <TextLeft>{t('common.agreementNumber')}</TextLeft>
        <TextRight>{trimLeadingZeros(agreementNumber ?? '')}</TextRight>
      </DottedContainer>
    </Container>
  );
};

const DottedContainer = styled(Container)`
  overflow: hidden;
  overflow-x: hidden;
  padding: 0;
  // ${theme.typography.textSmall}
  &::before {
    float: left;
    margin-top: 2px;
    width: 0;
    white-space: nowrap;
    color: ${theme.colors.black20};
    content: '............................................................................................................................................................................................................................................................................................................................................................................................................................';
  }
`;

const TextLeft = styled(Text)`
  float: left;
  padding-right: 4px;
  background-color: ${theme.colors.darkBlue};
  color: ${theme.colors.black20};
`;

const TextRight = styled(Text)`
  color: ${theme.colors.white};
  float: right;
  padding-left: 4px;
  background-color: ${theme.colors.darkBlue};
`;
